'use strict';
var style = 'wireframe';
var colorHelper = require('./colorHelper');
var appTypes = require('../types/appTypes');
var utils = require('./util');

function convertTextStyle(v) {
  var t = {fontWeight: 'normal', fontStyle: 'normal', textDecoration: 'none'};
  //[fsBold,fsItalic,fsUnderline,fsStrikeOut]
  if (typeof(v) === 'string') {
    if (v.indexOf('fsBold') !== -1) {
      t.fontWeight = 'bold';
    }
    if (v.indexOf('fsItalic') !== -1) {
      t.fontStyle = 'italic';
    }
    if (v.indexOf('fsUnderline') !== -1 && v.indexOf('fsStrikeOut') !== -1) {
      t.textDecoration = 'underline line-through';
    } else {
      if (v.indexOf('fsUnderline') !== -1) {
        t.textDecoration = 'underline';
      }
      if (v.indexOf('fsStrikeOut') !== -1) {
        t.textDecoration = 'line-through';
      }
    }
  }
  return t;
}

var noCoverColorPropName = ['isAutoTextColor', 'IsAutoTextColor'];

exports.convertValue = function (k, v) {
  if (k === 'dashMode') {
    return appTypes.DashMode[v] || 'solid';
  }
  if (k === 'text' || k === 'textFontFamily' || k === 'caption' || k === 'remarkText') {
    try {
      return _decodeURIComponent(v.replace(/\+/g, '%20'));
    } catch (e) {
      console.error(e);
      return "";
    }
  }

  if (k.toLowerCase().indexOf('color') !== -1 && noCoverColorPropName.indexOf(k) === -1) {
    return utils.Color.toHTMLColor(v);
  }

  if (k === 'textStyles') {
    return convertTextStyle(v);
  }

  if (v === 'true' || v === 'True') {
    return true;
  }
  if (v === 'false' || v === 'False') {
    return false;
  }
  if (k === 'selectedIndex' || k === 'gap' || k === 'thickness' || k === 'itemHeight') {
    return parseInt(v, 10);
  }
  return v;
};

exports.getAsset = function (name) {
  return '/src/assets/components/' + style + '/' + name + '.png';
};

exports.isLightColor = function (color) {
  var rgb = colorHelper.getRGBA(color);
  return rgb.R * 0.299 + rgb.G * 0.578 + rgb.B * 0.114 > 128;

  //Result := GetR(C) * 0.299 + GetG(C) * 0.587 + GetB(C) * 0.114 > 128;
};

function _decodeURI(txt) {
  try {
    return decodeURI(txt);
  } catch (e) {
    console.error(new Error("decodeURI " + txt + " error:" + e.message));
  }
  return txt;
}

exports.decodeURI = _decodeURI;

function _decodeURIComponent(txt) {
  try {
    return decodeURIComponent(txt);
  } catch (e) {
    console.error(new Error("decodeURIComponent " + txt + " error:" + e.message));
  }
  return txt;
}

exports.decodeURIComponent = _decodeURIComponent;


exports.isHttpURL = function () {
  var search = 'http';
  return window.location.href.substr(0, search.length) === search;
};



// WEBPACK FOOTER //
// ./src/helper/dataHelper.js